import { Button, Tab, TabProps, Theme, styled } from '@mui/material';
import { ErrorCircleIcon } from '@synergy/theme-next';
import { Link, To } from 'react-router-dom';
import { ReactElement, ReactNode } from 'react';
import { createStyles, makeStyles } from '@mui/styles';

import { PoolBadge } from '../pool-badge/pool-badge';
import { PoolRow } from '../pool-row/pool-row';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tabRoot: {
            textTransform: 'none',
            color: theme.palette.text.primary,
            '&.Mui-selected': {
                color: theme.palette.text.primary,
            },
            '&:hover': {
                backgroundColor: theme.palette.grey[100],
            },
        },
        badgeRoot: {
            flexDirection: 'row-reverse',
            alignItems: 'center',
        },
        badge: {
            top: 0,
            right: 0,
            position: 'relative',
            marginRight: theme.spacing(),
        },
    })
);

const StyledPoolBadge = styled(PoolBadge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        marginRight: theme.spacing(1),
    },
}));

export interface PoolTabOwnProps {
    badge?: ReactNode;
    linkTo?: To;
    isValid?: boolean;
    replace?: boolean;
}

export type PoolTabProps = PoolTabOwnProps & TabProps;

export const PoolTab = (props: PoolTabProps): ReactElement => {
    const classes = useStyles();

    const { label, badge, linkTo, isValid, replace, ...rest } = props;

    return (
        <Tab
            component={linkTo ? Link : Button}
            to={linkTo}
            replace={replace}
            classes={{ root: classes.tabRoot }}
            label={
                <PoolRow gap={0}>
                    {badge !== null && badge !== undefined && <StyledPoolBadge badgeContent={badge} showZero={true} />}
                    <PoolRow
                        gap={1}
                        sx={{ color: theme => (isValid === false ? theme.palette.error.main : undefined) }}
                    >
                        {isValid === false && <ErrorCircleIcon fontSize="small" />}
                        {label}
                    </PoolRow>
                </PoolRow>
            }
            // Type of rest diverges from TabProps if 'component' is set
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            {...(rest as any)}
        />
    );
};
